import React from 'react';
import {
  StatusPending,
  StatusRunning,
  StatusOK,
  StatusAborted,
  StatusError,
} from '@backstage/core-components';

export const WorkflowRunStatus = (props: { status: string | undefined }) => {
  const { status } = props;
  if (status === undefined) return null;
  switch (status.toLocaleLowerCase('en-US')) {
    case 'queued':
      return (
        <>
          <StatusPending /> Queued
        </>
      );
    case 'working':
      return (
        <>
          <StatusRunning /> Working
        </>
      );
    case 'success':
      return (
        <>
          <StatusOK /> Success
        </>
      );
    case 'cancelled':
      return (
        <>
          <StatusAborted /> Cancelled
        </>
      );
    case 'failure':
      return (
        <>
          <StatusError /> Failure
        </>
      );
    default:
      return (
        <>
          <StatusPending /> {status}
        </>
      );
  }
};
